import {
  List,
  Datagrid,
  TextField,
  NumberField,
  ReferenceField,
  EditButton,
  DeleteButton,
  FunctionField,
} from 'react-admin';
import { Chip } from '@mui/material';

export const ProductList = () => (
  <List>
    <Datagrid>
      <FunctionField
        label="Image"
        render={(record: any) => {
          const firstImage = record.images?.[0]?.media;
          
          if (!firstImage) return null;
          
          // Use thumbnail if available, otherwise fallback to original
          const imageUrl = firstImage.thumbnails?.find((t: any) => t.type === 'W550')?.url || firstImage.url;
          
          return (
            <img 
              src={imageUrl} 
              alt={record.name} 
              style={{ maxWidth: 50, maxHeight: 50, objectFit: 'cover' }} 
            />
          );
        }}
      />
      <TextField source="name" />
      <TextField source="sku" />
      <ReferenceField source="brandId" reference="brands" link="show">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField source="categoryId" reference="categories" link="show">
        <TextField source="name" />
      </ReferenceField>
      <NumberField source="price" options={{ style: 'currency', currency: 'USD' }} />
      <NumberField source="quantity" />
      <TextField source="status" />
      <FunctionField
        label="Tags"
        render={(record: any) =>
          record.tags?.map((tag: any) => (
            <Chip key={tag.id} label={tag.name} size="small" style={{ margin: 2 }} />
          ))
        }
      />
      <EditButton />
      <DeleteButton mutationMode="pessimistic" />
    </Datagrid>
  </List>
);
